import type { BuyingGuide } from './remainingSeoContentTypes';
import { RECIPIENT_GUIDES } from './recipientSeoContent';
import { FLOWER_SPECIES_GUIDES } from './flowerSpeciesSeoContent';
import { SEASONAL_OCCASION_GUIDES } from './seasonalOccasionSeoContent';
import { SPECIAL_OFFER_GUIDES } from './specialOfferSeoContent';
import { SUPPORTING_COLLECTION_GUIDES } from './supportingCollectionSeoContent';

export const REMAINING_SEO_GUIDES: Readonly<Record<string, BuyingGuide>> = {
  ...RECIPIENT_GUIDES,
  ...FLOWER_SPECIES_GUIDES,
  ...SEASONAL_OCCASION_GUIDES,
  ...SPECIAL_OFFER_GUIDES,
  ...SUPPORTING_COLLECTION_GUIDES,
};
